import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export const Footer = () => {

    return (
        <footer style={{backgroundImage: "url('./images/footer-bg.jpg')",backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat",}}>
            <div className="container">
                <div className="upper_footer row">
                    <div className="col-md-6 col-lg-4 col_margin">
                        <img src="./images/Sewa_1.svg" className="footr_logo" />
                        <p>We are your local health insurance advisors, certified by the NJ state and Federal Governtment. We help people just like you find health plans that provide peace of mind — not confusion.</p>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-3 col_margin">
                        <h3>Services</h3>
                        <div className="footer_links">
                            <Link to="/services">Individual and Family Insurance</Link>
                            <Link to="/services">Medicare Plans Made Simple</Link>
                            <Link to="/services">Short-Term, Vision, Dental & More</Link>
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-2 col_margin">
                        <h3>Links</h3>
                        <div className="footer_links">
                            <Link to="/">Home</Link>
                            <Link to="/services">Services</Link>
                            <Link to="/about-us">About Us</Link>
                            <Link to="/contact-us">Contact Us</Link>
                            <Link to="/faq">Faq</Link>
                            <Link to="/privacy-policy">Privacy Policy</Link>
                            <Link to="/terms-conditions">Terms & Conditions</Link>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-3 col_margin">
                        <h3>Contact Us</h3>
                        <div className="footer_contact">
                            <p><img src="./images/icon-location.svg" alt="Location" /> New Jersey — Serving<br /> clients across the country</p>
                            <Link to="tel: 6462430077"><img src="./images/icon-call.svg" alt="Phone" /> (646) 243-0077</Link>
                            <Link to="mailto: info@sewainsurance.com"><img src="./images/icon-envelope.svg" alt="Email" /> info@sewainsurance.com</Link>
                        </div>
                    </div>
                </div>
                <div className="footer_copyright text-center">Copyright ©2025 Sewa Insurance. All rights reserved.</div>
            </div>
        </footer>
    )
}